import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { site } from '@/mocks/columns';

const navs = [
  { to: '/', label: '首页' },
  { to: '/lanmu', label: '看料栏目' },
  { to: '/guanyu', label: '关于我们' },
  { to: '/lianxi', label: '联系我们' },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0 });
    setOpen(false);
  }, [location.pathname]);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/80 bg-background-50/90 backdrop-blur">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 md:px-6">
        <Link to="/" className="group flex items-center gap-3" aria-label="看料社首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-sm bg-primary-600 text-base font-bold text-background-50 shadow-line">
            料
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-xl font-bold tracking-wide text-foreground-950 group-hover:text-primary-700">
              看料社
            </span>
            <span className="mt-0.5 text-[10px] font-medium uppercase tracking-[0.25em] text-secondary-700">
              {site.latin}
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-7 md:flex" aria-label="主导航">
          {navs.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              className={({ isActive }) =>
                `whitespace-nowrap text-sm font-medium transition-colors ${
                  isActive ? 'text-primary-600' : 'text-foreground-700 hover:text-primary-600'
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <Link
            to="/lianxi"
            className="whitespace-nowrap rounded-md border border-primary-600 bg-primary-600 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700"
          >
            投稿 / 联系我们
          </Link>
        </div>

        <button
          type="button"
          aria-label="展开菜单"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-800 md:hidden"
        >
          <i className={`text-lg ri-${open ? 'close-line' : 'menu-line'}`} />
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <nav className="flex flex-col gap-1" aria-label="移动端导航">
            {navs.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                className={({ isActive }) =>
                  `rounded-md px-3 py-2.5 text-sm font-medium ${
                    isActive
                      ? 'bg-primary-100 text-primary-700'
                      : 'text-foreground-800 hover:bg-background-100'
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
            <Link
              to="/lianxi"
              className="mt-2 whitespace-nowrap rounded-md bg-primary-600 px-3 py-2.5 text-center text-sm font-medium text-background-50"
            >
              投稿 / 联系我们
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}